import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { clearRedirectPath, setRedirectPath } from '../common/redirectPath';
import { clearSession, hasValidSession } from '../auth/session';

// Same gate as useAuth, but for pages a guest can land on from an external link.
// Instead of dropping them on /bookings after login, it remembers the path they
// asked for and hands it back to the sign in flow.
// Returns true once the guest is signed in and it is safe to fetch.
const useAuthForLink = (returnPath) => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    if (!hasValidSession()) {
      // Remember where they were heading before sending them through sign in
      clearSession();
      setRedirectPath(returnPath);
      navigate('/');
      return;
    }

    clearRedirectPath();
    setIsAuthenticated(true);
  }, [navigate, returnPath]);

  return isAuthenticated;
};

export default useAuthForLink;
